import { capitalizeFirstLetters } from "./capitalizeFirstLetters";

export function makeHumanReadable(input: string | null | undefined): string {
  if (input && typeof input === "string") {
    return capitalizeFirstLetters(
      input.replaceAll("_", " ").replaceAll("-", " "),
    );
  }
  return "";
}
